<div>
  <div>
    <h2 [hidden]="!partnerCertificatesExternal.length">Internal certificates</h2>
    <dx-data-grid biz-grid
      #certDataGrid
      [selection]='{ mode: "none" }'
      [dataSource]='partnerCertificatesInternal'
      (bizOnToolbarPreparing)="onToolbarPreparing($event)"
      (onRowUpdating)="onRowUpdating($event)"
      (onRowRemoving)="onRowRemoving($event)">
      <dxo-editing mode="row"
        [allowUpdating]="allowUpdating"
        [allowAdding]="false"
      [allowDeleting]="allowDeleting"></dxo-editing>
      <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

      <dxi-column dataField="Usages" caption="Usage" #columnUsages cellTemplate="usageViewTemplate" [calculateFilterExpression]="calculateUsagesFilterExpression">
        <dxo-header-filter [dataSource]="getUsagesFilterData()"></dxo-header-filter>
      </dxi-column>
      <dxi-column dataField="CertificateType.Name" caption="Type" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="HasPrivateKey" caption="Private key" dataType="boolean" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="HasPublicKey" caption="Public key" dataType="boolean" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="StartUsing" caption="Start using date" dataType="date" format="shortDateShortTime"></dxi-column>
      <dxi-column dataField="ValidFrom" caption="Valid from" dataType="date" format="shortDateShortTime" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="ValidTo" caption="Valid to" dataType="date" format="shortDateShortTime" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="FriendlyName" caption="Friendly name" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="Issuer" caption="Issuer" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="Subject" caption="Subject" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="SerialNumber" caption="Serial number" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="ShowInPicker" caption="Show in picker" dataType="boolean"></dxi-column>
      <dxi-column dataField="DisplayName" caption="Display name" dataType="string"></dxi-column>
      <dxi-column dataField="Comment" caption="Comment" dataType="string" [allowEditing]="true"></dxi-column>
      <dxi-column caption="#" cellTemplate="downloadTemplate" [fixed]="true" fixedPosition="right" [visible]="allowDownload" [showInColumnChooser]="allowDownload"></dxi-column>
      <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
            <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(partnerCertificatesInternal, 'CreatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
        <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
            <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(partnerCertificatesInternal, 'UpdatedBy'))"></dxo-header-filter>
        </dxi-column>
        <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false" format="dateTime"></dxi-column>

      <div *dxTemplate="let cell of 'usageViewTemplate'">
        @for (usage of cell.data.Usages; track usage; let isLast = $last) {
          <span>{{usage.Name}}{{isLast ? '' : ', '}}</span>
        }
      </div>
      <div *dxTemplate="let cell of 'downloadTemplate'">
        <button class="btn btn-link np" (click)="downloadCertificate(cell.data)">Download</button>
      </div>
    </dx-data-grid>
  </div>

  <div [hidden]="!partnerCertificatesExternal.length">
    <h2>External certificates</h2>
    <label class="label label-default">These certificates are maintained by external systems via the web-service layer.</label>
    <dx-data-grid biz-grid
      [selection]='{ mode: "none" }'
      [dataSource]='partnerCertificatesExternal'
      (onRowUpdating)="onRowUpdating($event)"
      (onRowRemoving)="onRowRemoving($event)">
      <dxo-editing mode="row"
        [allowUpdating]="false"
        [allowAdding]="false"
      [allowDeleting]="false"></dxo-editing>
      <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

      <dxi-column dataField="Usages" caption="Usage" #columnUsages cellTemplate="usageViewTemplate"></dxi-column>
      <dxi-column dataField="CertificateType.Name" caption="Type" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="HasPrivateKey" caption="Private key" dataType="boolean" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="HasPublicKey" caption="Public key" dataType="boolean" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="StartUsing" caption="Start using date" dataType="date" format="shortDateShortTime"></dxi-column>
      <dxi-column dataField="ValidFrom" caption="Valid from" dataType="date" format="shortDateShortTime" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="ValidTo" caption="Valid to" dataType="date" format="shortDateShortTime" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="FriendlyName" caption="Friendly name" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="Issuer" caption="Issuer" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="Subject" caption="Subject" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="SerialNumber" caption="Serial number" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="ShowInPicker" caption="Show in picker" dataType="boolean"></dxi-column>
      <dxi-column dataField="DisplayName" caption="Display name" dataType="string"></dxi-column>
      <dxi-column dataField="ExternalForeignKey" caption="External key" dataType="string" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="Comment" caption="Comment" dataType="string" [allowEditing]="true"></dxi-column>

      <div *dxTemplate="let cell of 'usageViewTemplate'">
        @for (usage of cell.data.Usages; track usage; let isLast = $last) {
          <span>{{usage.Name}}{{isLast ? '' : ', '}}</span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>

<ng-template #showCertificates let-c="close" let-d="dismiss">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Certificates in file</h4>
    <span class="label label-default">Type {{parsedCertificateType}}</span>
  </div>
  <div class="form-group modal-body">
    @for (certificate of certificateParseResult?.PartnerCertificates; track certificate; let isLast = $last) {
      <div>
        <div class="row">
          <div class="col-sm-6 col-md-4 form-group">
            @switch (getCertificateStatus(certificate)) {
              @case ('Invalid') {
                <label class="label label-danger">
                  This certificate is no longer valid
                </label>
              }
              @case ('Imported') {
                <label class="label label-warning">
                  This certificate is already imported for this partner
                </label>
              }
              @default {
                <label class="control control-checkbox">
                  <input type="checkbox" [disabled]="certificate.alreadyImported" [(ngModel)]="certificate.isSelected"
                    (ngModelChange)="onUpdateImportSaveButton($event)" />
                    <i></i>
                    Import this certificate
                  </label>
                }
              }
            </div>
          </div>
          <div class="row" [hidden]="!certificate.isSelected">
            <div class="col-sm-4 form-group">
              <label>Start using date</label>
              <ep-datetime-picker [minDate]="certificate.ValidFrom" [maxDate]="certificate.ValidTo"
              type="datetime" (selectedDatetimeChange)="certificate.StartUsing = $event"></ep-datetime-picker>
            </div>
            <div class="col-sm-4 form-group">
              <label>Usage</label>
              <dx-tag-box [(ngModel)]="certificate.Usages" (ngModelChange)="onUpdateImportSaveButton()"
                [dataSource]="partnerCertificateUsages" [showSelectionControls]="true" displayExpr="Name">
              </dx-tag-box>
            </div>
            <div class="col-sm-4 form-group">
              <label>Comment</label>
              <input type="text" class="form-control" [(ngModel)]="certificate.Comment" />
            </div>
          </div>
          <div class="row" [hidden]="!certificate.isSelected">
            <div class="col-sm-4 form-group">
              <label>Show in picker</label>
              <label class="control control-checkbox">
                <input type="checkbox" [(ngModel)]="certificate.ShowInPicker" (ngModelChange)="onUpdateImportSaveButton()" />
                <i></i>
              </label>
            </div>
            <div class="col-sm-8 form-group">
              <label>Display name</label>
              <input type="text" class="form-control" [(ngModel)]="certificate.DisplayName" (ngModelChange)="onUpdateImportSaveButton()" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 form-group">
              <label>Friendly name</label>
              <p>{{certificate.FriendlyName}}</p>
            </div>
            <div class="col-sm-4 form-group">
              <label>Issuer</label>
              <p>{{certificate.Issuer}}</p>
            </div>
            <div class="col-sm-4 form-group">
              <label>Subject</label>
              <p>{{certificate.Subject}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 form-group">
              <label>Valid from</label>
              <p>{{certificate.ValidFrom | date:'medium'}}</p>
            </div>
            <div class="col-sm-4 form-group">
              <label>Valid to</label>
              <p [ngClass]="{'text-danger': !certificate.isValid}">{{certificate.ValidTo | date:'medium'}}</p>
            </div>
            <div class="col-sm-4 form-group">
              <label>Serial number</label>
              <p>{{certificate.SerialNumber}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 form-group">
              <label>Has public key</label>
              <p>{{certificate.HasPublicKey ? 'Yes' : 'No'}}</p>
            </div>
            <div class="col-sm-4 form-group">
              <label>Has private key</label>
              <p>{{certificate.HasPrivateKey ? 'Yes' : 'No'}}</p>
            </div>
          </div>
          @if (!isLast) {
            <hr />
          }
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="!enableImportSaveButton" (click)="c()">Save</button>
      <button type="button" class="btn btn-link" (click)="d()">Cancel</button>
    </div>
  </ng-template>
